import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { CheckFilledCircleIcon } from '@gemini/icons';
import { useTranslation } from '@/hooks/useTranslations';
import { AddFootnoteRef } from '@/components/tools/footnotes';
export const List = ({ items, spacing = 'spacing.16' }) => {
    const { t } = useTranslation();
    return (_jsx(Box, { as: "ul", unsafe_style: { listStyle: 'none' }, margin: "spacing.none", padding: "spacing.none", children: items.map((item) => (_jsxs(Box, { as: "li", marginBottom: spacing, display: "flex", alignItems: "center", gap: "spacing.16", children: [_jsx(CheckFilledCircleIcon, { size: "sizing.20" }), ' ', AddFootnoteRef(t(`${item.text}`))] }, item.id))) }));
};
